import React, { useState } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import AddedPersonTable from 'app/edozvola/cases/added-person/added-person-table';
import AddedPersonForm from 'app/edozvola/cases/added-person/added-person-form';
import { getCaseContext } from 'app/shared/util/context-util';

const AddedPerson = () => {
  const [addedPersonId, setAddedPersonId] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const openNeAddedPersonForm = () => {
    setAddedPersonId('');
    setReadOnly(false);
  };

  return (
    <>
      <h6 className={'form-header'}>Dodane osobe</h6>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className={'d-flex justify-content-end pb-4 gap-2'}>
            <Button label={'Dodaj osobu'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openNeAddedPersonForm} />
          </div>
        </>
      )}

      <AddedPersonTable setAddedPerson={setAddedPersonId} setReadOnly={setReadOnly} />
      {addedPersonId !== null && <AddedPersonForm addedPersonId={addedPersonId} setAddedPersonId={setAddedPersonId} readOnly={readOnly} />}
    </>
  );
};

export default AddedPerson;
